import cn from 'classnames'
import type { ReactNode } from 'react'
import React from 'react'

import { CourseKitSize } from '../CourseKitTypes'
import * as s from './Empty.module.scss'
import EmptySVG from './assets/empty.svg?react'

export const ILLUSTRATIONS = {
  empty: EmptySVG,
}

/**
 * Props for the Empty component.
 */
export interface IEmptyProps {
  /**
   * The text to display in the Empty component.
   */
  text?: ReactNode

  /**
   * The icon to display in the Empty component.
   */
  icon?: keyof typeof ILLUSTRATIONS | null

  /**
   * A custom icon component to display in the Empty component.
   */
  CustomIcon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>

  /**
   * The size of the Icon.
   */
  size?: CourseKitSize

  /**
   * Whether the Empty component should grow to fill available space.
   * @example
   * ```scss
   * .grow {
   *  width: 100%;
   *  height: 100%;
   *  flex-grow: 1;
   * }
   * ```
   */
  grow?: boolean

  /**
   * Whether the component should be positioned absolutely.
   */
  absolute?: boolean
}

const Empty: React.FC<IEmptyProps> = ({
  text,
  icon = 'empty',
  size = CourseKitSize.S,
  grow,
  absolute,
  CustomIcon,
}) => {
  const Icon = icon && ILLUSTRATIONS[icon]
  return (
    <div className={cn(s.root, s[size], { [s.grow]: grow, [s.absolute]: absolute })}>
      {(CustomIcon && <CustomIcon height='1em' width='1em' />) ||
        (Icon && <Icon height='1em' width='1em' />)}
      {text && <div className={s.hint}>{text}</div>}
    </div>
  )
}

export default Empty
